interface HeaderProps {
  title: string;
}
const Header: React.FC<HeaderProps> = ({ title }) => {
  return (
    <header>
      <nav className="navbar-expand-sm navbar-light">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-12">
              <span className="page-heading">{title}</span>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
};
export default Header;
